

































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import Viewpoints from "@/store/modules/Viewpoints";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import FactorNavigation from "@/components/navigation/FactorNavigation.vue";
import Dialogs from "@/store/modules/Dialogs";
import Modelling from "@/store/modules/Modelling";
import { FactorGroup } from "@/api/model/FactorResource";
import Decisions from "@/store/modules/Decisions";
import _ from "lodash";

const decisionsModule = getModule(Decisions)
const viewpointsModule = getModule(Viewpoints);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const modellingModule = getModule(Modelling)
@Component({
    components: {FactorNavigationTree: FactorNavigation}
})
export default class FactorNavigationPublishedModel extends Vue {

    @Prop({default: null, type: String})
    search!: string | null;

    @Prop({default: false, type: Boolean})
    openAll!: boolean;

    @Prop({default: false, type: Boolean})
    menuVisible!: boolean;

    @Prop({default: false, type: Boolean})
    menuEdit!: boolean;

    @Prop({default: false, type: Boolean})
    menuNew!: boolean;

    @Prop({default: false, type: Boolean})
    menuFolderToggle!: boolean;

    @Prop({default: '', type: String})
    clickUrl!: string;

    @Prop({default: 'Select a Factor', type: String})
    header!: string;

    @Prop({default: false, type: Boolean})
    checkable!: boolean;

    @Prop({default: null, type: Boolean})
    trimFactors!: boolean

    @Prop({default: () => ([]), type: Array})
    selections!: string[];

    private selectedFactors: string[] = [];
    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get selectedViewpoints() {
        return viewpointsModule.selectedViewpoints
    }

    get factorResourceTree() {
        if (this.factorResources && this.factorResources['M']) {
            return this.getSubTree(this.startingFactors);
        }
    }

      get startingFactors() {
        if(workspaceOptionsModule.trimTopGroups) {
            let topFactor = 'M'
            return this.getTopGroup('M')
        
        } else {
            return 'M'
        }
        
    }

    private getTopGroup(topId: string) {
        if(!workspaceOptionsModule.trimTopGroups) {
            return topId;
        }

        if(this.factorResources[topId].childrenIds.length != 1 ? true: 'groupTypeDefinition' in this.factorResources[this.factorResources[topId].childrenIds[0]] || this.factorResources[this.factorResources[topId].childrenIds[0]].type != 'FACTOR_GROUP') {
            return topId
        }

        if(this.factorResources[topId].childrenIds.length === 1) {
            return this.getTopGroup(this.factorResources[topId].childrenIds[0])
        }
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources
    }

    get selectionPath() {
        return workspaceOptionsModule.selectionPath;
    }

    get selectedFactorResourceItemId() {
        return workspaceOptionsModule.selectedPathItemId
    }

    get contributingFactors() {
        return viewpointsModule.contributingFactorResources
    }

    get contributingVisibility() {
        return workspaceOptionsModule.contributingFactorVisibility
    }

    get factorListTree(){
        return modellingModule.factorListTree
    }

    get isViewpointActive() {
        return (viewpointsModule.activeViewpointId != null)
    }

    get isFactorListActive() {
        return workspaceOptionsModule.activeFactorLists.length > 0
    }

    get showNonListFactors() {
        return workspaceOptionsModule.showNonListFactors;
    }

     private isFactorVisible(resourceId: string) {
        //Check trim factors variable - null is non list input, false/true is list input
        switch(this.trimFactors) {
            //If list input and trimming is true
            case true:
                if(this.isFactorListActive && this.factorListTree[resourceId] && !this.showNonListFactors) {
                    return true
                } else
                    return false
            //If list input and trimming is false
            case false: 
                return true

            //If not list input
            default:
                //If no list active or showallFactors button toggled on
                if(this.showNonListFactors || !this.isFactorListActive) {
                    //return this.contributingVisibility || (!this.contributingVisibility && this.contributingFactors[resourceId])
                    return true;
                }
                //If list active and showAllFactors is off, then filter 
                else {
                    if(this.isFactorListActive && this.factorListTree[resourceId] && !this.showNonListFactors) {
                            return true
                    } else
                        return false;
                }
        } 
       
    }

    private getSubTree(factorResourceId: string): { id: string, name?: string, children: any[] } {
        let factorGroup = this.factorResources[factorResourceId] as FactorGroup;
        let childrenIds: string[];
        if (
            factorGroup.groupTypeDefinition
            && (
                factorGroup.groupTypeDefinition.type === 'TABLE_FIXED'
                // TODO - Temp off to hide row/cols of Fixed Tables (Dion 2021-01-27)
                // || factorGroup.groupTypeDefinition.type === 'TABLE_GROWING'
            )
        ) {
            /*
            childrenIds = factorGroup.childrenIds
                .map(f => this.factorResources[f])
                .filter(f => f)
                .filter(f => f.type === 'FACTOR_GROUP' && (f as FactorGroup).groupTypeDefinition.type === 'TABLE_COLUMN')
                .map(f => f.id);
            // This will update the factor names to display correctly
            let rows = factorGroup.childrenIds
                .map(f => this.factorResources[f])
                .filter(f => f)// contributing
                .filter(f => f.type === 'FACTOR_GROUP' && (f as FactorGroup).groupTypeDefinition.type === 'TABLE_ROW') as FactorGroup[]
            for (let colId of childrenIds) {
                let column = this.factorResources[colId] as FactorGroup
                if (!column) continue;
                column.childrenIds.forEach(id => {
                    let row = rows.find(r => r.childrenIds.includes(id))
                    if (row && this.factorResources[id]) {
                        this.factorResources[id].name = row.name
                    }
                })
            }
            */
        } else {
            
            childrenIds = this.factorResources[this.getTopGroup(factorGroup.id)].childrenIds || [];
        }
        if (!childrenIds) { childrenIds = []; }
        let children = childrenIds
            .filter(id => this.isFactorVisible(id))
            .filter(f => this.factorResources[f])
            .map((cId: string) => {
                let resource = this.factorResources[cId];
                if (resource.type === 'FACTOR') {
                    return {
                        id: cId,
                        name: resource.name
                    }
                }
                return this.getSubTree(cId)
            })

        return {
            id: factorResourceId,
            name: factorGroup.name,
            children: children
        }
    }

    private selectFactorResource(itemId: string) {
        if (itemId) {
            workspaceOptionsModule.selectBreadcrumbItem(itemId);
            workspaceOptionsModule.updateExpansions(itemId);
            if (this.clickUrl) {
                if (this.$route.path !== this.clickUrl) {
                    this.$router.push(this.clickUrl);
                }
            }
        }
    }

    private selectScoringDefinitionEdit(factorId: string) {
        if (this.selectedViewpoints && this.selectedViewpoints.length === 1) {
            getModule(Dialogs).editScoringDefinition({
                viewpointId: this.selectedViewpoints[0].viewpointId,
                resourceId: factorId
            })
        }
    }

    private selectScoringKeyEdit(factorId: string) {
        if (this.selectedViewpoints && this.selectedViewpoints.length === 1) {
            getModule(Dialogs).editScoringKey({
                viewpointId: this.selectedViewpoints[0].viewpointId,
                resourceId: factorId
            })
        }
    }

    @Watch('selections')
        onChangeSelections(newVal: any, oldVal: any) {
            if(!_.isEqual(newVal, this.selectedFactors))
                this.selectedFactors = this.selections;
    }

    private onChangeSelectedFactors(value: string[], oldVal: string[]) {
        if(value != oldVal) {
            this.selectedFactors = value;
            this.$emit('selections', this.selectedFactors)
        }
       
    }

}
